import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { isEmpty } from 'lodash-es';
import PropTypes from 'prop-types';
import ImageUploading from 'react-images-uploading';
import { StyledImgUploadContainer, StyledUploadImgArea, StyledCancelIcon, StyledPreviewImg } from './ImageUploader.styles.js';
import { parseFilenames, imgFileTypes } from './utils.js';
import LoadingImg from '../assets/img/loading.gif.js';
function ImageUploader(_ref) {
  let {
    value,
    onChange,
    onDelete,
    style,
    max,
    maxFileSize,
    onRenderUpload,
    setImagesError,
    multiple,
    previewWidth,
    previewHeight,
    previewBorderRadius,
    uploadImgLoading,
    height,
    width,
    uploadText,
    uploadIcon,
    acceptType
  } = _ref;
  const [localErrors, setLocalErrors] = useState({});
  const renderUploadImgArea = _ref2 => {
    let {
      imageList
    } = _ref2;
    const imgDataForShow = parseFilenames(imageList);

    /* 如果是上傳單一圖片 並且 有圖片 則顯示圖片 */
    if (!isEmpty(imageList) && !multiple) {
      return /*#__PURE__*/React__default.createElement(Box, {
        position: "relative"
      }, imgDataForShow.map((imgInfo, index) => /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React__default.createElement(React__default.Fragment, {
        key: index
      }, imgFileTypes.includes(imgInfo.extension) ? /*#__PURE__*/React__default.createElement(StyledPreviewImg, {
        component: "img",
        src: imgInfo.img,
        previewWidth: previewWidth,
        previewHeight: previewHeight,
        previewBorderRadius: previewBorderRadius
      }) : /*#__PURE__*/React__default.createElement(Box, {
        color: theme => theme.customColors.purple[500]
      }, /*#__PURE__*/React__default.createElement(Box, {
        component: "div",
        className: "meta-crm-icon-ic_file_outline font-size-64"
      }), /*#__PURE__*/React__default.createElement(Box, null, imgInfo.name && imgInfo.name)))));
    }
    return uploadIcon;
  };
  const renderUploadText = _ref3 => {
    let {
      isMax,
      imageList
    } = _ref3;
    /* 如果是上傳單一圖片 並且 有圖片 則不顯示任何字樣 */
    if (!isEmpty(imageList) && !multiple) {
      return null;
    }
    return isMax ? 'Image limit reached' : uploadText;
  };
  const renderUpload = _ref4 => {
    let {
      onImageUpload,
      dragProps,
      isMax,
      imageList
    } = _ref4;
    return /*#__PURE__*/React__default.createElement(StyledUploadImgArea, _extends({
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "14px",
      width: "100%",
      height: "100%",
      onClick: isMax ? null : onImageUpload
    }, dragProps, {
      isMax: isMax,
      color: "secondary",
      position: 'relative'
    }), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderUploadImgArea({
      isMax,
      imageList
    }), renderUploadText({
      isMax,
      imageList
    })), !isEmpty(imageList) && /*#__PURE__*/React__default.createElement(StyledCancelIcon, {
      onClick: onDelete
    }));
  };
  useEffect(() => {
    setImagesError(localErrors);
  }, [localErrors, setImagesError]);
  return /*#__PURE__*/React__default.createElement(StyledImgUploadContainer, {
    value: value,
    uploadImgLoading: uploadImgLoading,
    height: height,
    width: width
  }, uploadImgLoading ? /*#__PURE__*/React__default.createElement(Box, {
    padding: "14px"
  }, /*#__PURE__*/React__default.createElement(Box, {
    component: "img",
    src: LoadingImg,
    alt: "loading",
    width: "60px"
  }), /*#__PURE__*/React__default.createElement(Box, null, "Loading...")) : /*#__PURE__*/React__default.createElement(ImageUploading, {
    multiple: multiple,
    allowNonImageType: true,
    maxNumber: max,
    maxFileSize: maxFileSize,
    value: value,
    acceptType: acceptType,
    onChange: (imageList, addUpdateIndex) => {
      const list = imageList;
      onChange(list, addUpdateIndex);
    },
    dataURLKey: "data_url"
  }, _ref5 => {
    let {
      imageList,
      onImageUpload,
      dragProps,
      errors
    } = _ref5;
    // setTimeout 輕微延遲錯誤的設定，這樣它就不會在當前的渲染周期內發生。
    setTimeout(() => {
      setLocalErrors(errors);
    }, 0);
    const isMax = imageList.length >= max;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, onRenderUpload ? onRenderUpload({
      onImageUpload,
      dragProps,
      isMax,
      imageList,
      multiple
    }) : renderUpload({
      onImageUpload,
      dragProps,
      isMax,
      imageList,
      multiple
    }));
  }));
}
ImageUploader.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
  style: PropTypes.shape({}),
  max: PropTypes.number,
  maxFileSize: PropTypes.number,
  onRenderUpload: PropTypes.func,
  setImagesError: PropTypes.func,
  multiple: PropTypes.bool,
  previewWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  previewHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  previewBorderRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  uploadImgLoading: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  uploadText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  uploadIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  acceptType: PropTypes.shape([])
};
ImageUploader.defaultProps = {
  value: '',
  onChange: null,
  onDelete: null,
  style: {},
  max: 3,
  maxFileSize: 10 * 1024 * 1024,
  onRenderUpload: null,
  setImagesError: () => {},
  multiple: false,
  previewWidth: 100,
  previewHeight: 'unset',
  previewBorderRadius: '5px',
  uploadImgLoading: false,
  height: 300,
  width: 500,
  uploadText: /*#__PURE__*/React__default.createElement(Box, {
    display: 'flex',
    flexDirection: "column",
    alignItems: 'center'
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      fontWeight: 700,
      color: '#222',
      fontSize: '14px',
      marginBottom: '4px'
    }
  }, "Upload file"), /*#__PURE__*/React__default.createElement(Box, null, "Click to upload or drag & drop")),
  uploadIcon: /*#__PURE__*/React__default.createElement(Box, {
    component: "i",
    className: "meta-crm-icon-ic_uploadImage font-size-44",
    color: theme => theme.customColors.purple[500],
    marginBottom: "12px"
  }),
  acceptType: ['png', 'jpg', 'jpeg', 'pdf']
};
export { ImageUploader as default };